import { Component, OnInit } from '@angular/core';
import { SignupFlowService } from '@app/modules/signup-new/services/signup-flow.service';
import { SignupStepperService } from '@app/modules/signup-new/services/signup-stepper.service';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { SignupChannel } from '@app/modules/user/signup/signup.interface';
import { ScriptLoaderService } from '@app/shared/services/script-loader/script-loader.service';
import { decodeToRealUserId, Logger } from '@app/shared/utils';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'sbnb-signup-done-page',
  templateUrl: './signup-done-page.component.html',
})
export class SignupDonePageComponent implements OnInit {
  loading = false;
  platform: string;
  isAirbnbSignup = false;

  constructor(
    private signupStepperService: SignupStepperService,
    private signupUserService: SignupUserService,
    private scriptLoader: ScriptLoaderService,
    private signupFlowService: SignupFlowService
  ) {}

  ngOnInit() {
    this.isAirbnbSignup = this.signupUserService.isAirbnbSignup;

    if (this.signupUserService.hasChannel(SignupChannel.Airbnb)) {
      this.platform = SignupChannel.Airbnb;
    } else if (this.signupUserService.hasChannel(SignupChannel.Vrbo)) {
      this.platform = SignupChannel.Vrbo;
    } else if (this.signupUserService.hasChannel(SignupChannel.BookingDotCom)) {
      this.platform = 'Booking.com';
    } else {
      this.platform = SignupChannel.Airbnb;
    }

    this.registerConversionWithMountain();
  }

  registerConversionWithMountain() {
    const user = this.signupUserService.user$.value;
    if (!user) return;

    window.mountainConfig = { orderId: decodeToRealUserId(user.id, user.email) };

    this.scriptLoader.load({ name: 'Mountain', src: '/assets/js/mountain.js' }).subscribe(
      () => Logger.log('Mountain: tracked conversion'),
      () => Logger.log('Mountain failed to track conversion')
    );
  }

  onContinue(redirectUrl?: string) {
    this.loading = true;
    this.signupUserService
      .completeSignup(redirectUrl)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.signupFlowService.reset();
        this.signupStepperService.reset();
      });
  }
}
